module.exports = __webpack_public_path__ + "img/ic_event_note.84d31465.svg";